document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.l-header-button__inner');
  const menu = document.querySelector('.l-header-main');

  if (!toggle || !menu) return;

  // トグルクリック（開閉）
  toggle.addEventListener('click', function (e) {
    e.stopPropagation(); // 外クリック判定を防ぐ
    toggle.classList.toggle('is-current');
    document.body.classList.toggle('header-open-contents');
  });

  // メニュー内クリックは閉じない
  menu.addEventListener('click', function (e) {
    e.stopPropagation();
  });

  // メニュー外クリックで閉じる
  document.addEventListener('click', function () {
    if (!toggle.classList.contains('is-current')) return;

    toggle.classList.remove('is-current');
    document.body.classList.remove('header-open-contents');
  });
});
